export const GetSensors = "GetSensors";
export const GetSensorsSuccess = "GetSensorsSuccess";
export const GetSensorsError = "GetSensorsError";
